export default {
  'dashboard.title': 'Sendcloud 物流工具',
  'dashboard.ms': 'shopline无缝对接Sendcloud,在shopline就可以使用Sendcloud发货',
  'dashboard.key.title': 'Sendcloud 密钥配置',
  'dashboard.key.title.ms': '请配置您Sendcloud生成的密钥',
  'dashboard.key.name.placeholder': '请输入Name',
  'dashboard.key.name.publickey.placeholder': '请输入 public key',
  'dashboard.key.name.secretkey.placeholder': '请输入 secret key',
  'dashboard.key.btn.save': '保存',
  'dashboard.order.push.title': '订单推送配置',
  'dashboard.order.push.title.ms': '推送功能开关，范围配置',
  'dashboard.order.push.realtime': '实时推送',
  'dashboard.order.push.range': '范围推送',
  'dashboard.order.push.btn': '提交',
  'dashboard.order.push.log.title': '推送日志',
  'dashboard.order.push.log.title.ms': '管理所有推送的订单记录',
  'dashboard.order.push.log.title.order.ms': '订单推送日志',
  'dashboard.order.push.log.title.order.btn': '跳转',
  'dashboard.sendcloud.title.ms': '登录您的Sendcloud管理后台',
  'dashboard.key.name.msg': '请输入name',
  'dashboard.key.publickey.msg': '请输入 publicKey',
  'dashboard.key.secretKey.msg': '请输入 secretKey',
  'btn.save.message': '保存成功',
  'help.doc.title': '帮助文档',
  'btn.range.push.message': '同步成功',
  'time.then.30.day': '选择的日期范围不能大于30天',
  'select.range,date': '请选择日期范围',
  'orders.found.res': '个订单',
  'dashboard.sendcloud.webhook.title': 'Sendcloud WebHook Url',
  'dashboard.sendcloud.webhook.ms': 'Sendcloud 航运状态回写地址',
  'dashboard.sendcloud.webhook.btn.text': '复制',
  'dashboard.sendcloud.webhook.btn.copy.info': '复制成功',
  'dashboard.sendcloud.api.version.title': 'Sendcloud Api 版本选择',
  'dashboard.sendcloud.api.version.desc': '选择Sendcloud Api的版本',
  'dashboard.sendcloud.api.version.card.title': '选择Sendcloud Api的版本',
  'dashboard.sendcloud.api.version.card.integration.title': 'Sendcloud集成',
  'dashboard.sendcloud.api.version.card.integration.info': '请选择集成对象'
}



// WEBPACK FOOTER //
// ./src/locales/lang/zh-CN/dashboard/config.js